<script setup lang="ts">
  import { onBeforeUnmount, onMounted } from 'vue'
  import { useSearchGlobalStore } from '@/stores/search-global'

  const emit = defineEmits<{
    (e: 'openSearch'): void,
  }>()

  const searchGlobal = useSearchGlobalStore()

  const inputElement = () => {
    return document.querySelector<HTMLInputElement>('#sidebarSearch')
  }

  const openSearch = () => {
    emit('openSearch')
  }

  onMounted(() => {
    inputElement()?.addEventListener('click', openSearch)
  })
  onBeforeUnmount(() => {
    inputElement()?.removeEventListener('click', openSearch)
  })
</script>

<template>
  <app-search
    id="sidebarSearch"
    v-model="searchGlobal.search" />
</template>
